<template>
    <v-container class="pt-0">

        <v-row>
            <v-col cols="12" class="text-left px-0 pt-0">

                <div v-if="comercio.image == null">
                    <v-img
                    class="white--text align-end"
                    height="200px"
                    src="@/assets/img/restaurant/restaurant-default.jpg"
                    >
                    </v-img>
                </div>
                <div v-else>
                    <v-img
                    class="white--text align-end"
                    height="200px"
                    :src="comercio.img_uri_commerce+'/'+comercio.image"
                    >
                    </v-img>
                </div>

                <div class="mx-5">
                    <v-row>
                        <v-col cols="3">
                            <div v-if="comercio.logo == null">
                                <v-avatar 
                                size="60">
                                    <img
                                        src="@/assets/img/restaurant/logo-default.jpg"
                                    >
                                </v-avatar>
                            </div>
                            <div v-else>
                                <v-avatar 
                                size="60">
                                    <img
                                        :src="comercio.img_uri_commerce+'/'+comercio.logo"
                                    >
                                </v-avatar>
                            </div>
                        </v-col>
                        <v-col cols="9" class="my-auto pt-5">
                            <h3>{{ this.comercio.name }}</h3>
                            <p>{{ this.comercio.address }}</p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="text-left">
                            <p>{{ this.comercio.description }}</p>
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col cols="auto">
                            <v-btn color="#ffc068" dark v-on:click="abrirFiltroAlergenos()"><vue-material-icon name="filter_list" :size="20"></vue-material-icon> Filtro alérgenos</v-btn>
                        </v-col> 
                    </v-row>

                </div>

                <div>
                    <v-col cols="12" class="text-left px-0">
                        <v-card>
                            <v-tabs
                                background-color="transparent"
                                show-arrows
                                v-model="categoriaSeleccionada"
                            >
                                <v-tabs-slider color="lighten-3" ></v-tabs-slider>

                                <v-tab v-for="(categoria,index) in categorias" :key="index" @click="filtrarPlatos(index)">{{ categoria.name}}

                                </v-tab>

                            </v-tabs>
                        </v-card>
                    </v-col>
                </div>
                
                <div>
                    
                    <v-col cols="12" class="pb-0 px-5 text-center" v-show="this.categoriaDescripcion">
                        <p><b>{{ this.categoriaDescripcion }}</b></p>
                    </v-col>

                    <v-col cols="12" class="pb-0" v-for="(plato,index) in platos" :key="index"  @click="abrirModal(plato)">
                          <v-card elevation="5">
                            <v-row justify="center">
                                <v-col
                                cols="8"
                                class="text-left"
                                >
                                    <h3 style="color:grey">{{ plato.name }}</h3>
                                    <span v-for="(ingrediente,index) in plato.json.ingredients" :key="index">{{ ingrediente }}, </span>
                                    <v-row class="py-0">

                                        <v-col cols="4" class="py-0" v-if="plato.price">
                                            <small><b>{{ plato.col_price['es-ES'] }}</b></small><br>
                                            {{ formatoPrecio(plato.price) }}
                                        </v-col>

                                        <v-col cols="4" class="py-0" v-if="plato.price_1">
                                            <small><b>{{ plato.col_price_1['es-ES'] }}</b></small><br>
                                            {{ formatoPrecio(plato.price_1) }}
                                        </v-col>

                                        <v-col cols="4" class="py-0" v-if="plato.price_2">
                                            <small><b>{{ plato.col_price_2['es-ES'] }}</b></small><br>
                                            {{ formatoPrecio(plato.price_2) }}
                                        </v-col>

                                        <v-col cols="4" class="py-0" v-if="plato.price_3">
                                            <small><b>{{ plato.col_price_3['es-ES'] }}</b></small><br>
                                            {{ formatoPrecio(plato.price_3) }}
                                        </v-col>

                                        <v-col cols="4" class="py-0" v-if="plato.price_4">
                                            <small><b>{{ plato.col_price_4['es-ES'] }}</b></small><br>
                                            {{ formatoPrecio(plato.price_4) }}
                                        </v-col>

                                    </v-row>
                                </v-col>

                                <v-col cols="3" class="py-1 pl-4">
                                    <div v-if="plato.image == null">
                                        <v-img
                                        height="80"
                                        width="80"
                                        src="@/assets/img/restaurant/plato-default.jpg"
                                        style="border-radius:5px"
                                        gradient="to top left, rgba(255,255,255,.33), rgba(255,255,255,.7)"
                                        ></v-img>
                                    </div>
                                    <div v-else>
                                        <v-img
                                        height="80"
                                        width="80"
                                        :src="plato.img_uri_plates+'/'+plato.image"
                                        style="border-radius:5px"
                                        ></v-img>
                                    </div>
                                    
                                </v-col>

                            </v-row>

                            <v-row class="text-center mx-3">
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.gluten">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/gluten.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.crutaceans">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/crustaceo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.eggs">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/huevo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.fish">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/pescado.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.peanut">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/cacahuetes.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.soya">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/soja.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.milk">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/lacteo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.tree_nuts">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/fruto-cascara.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.celery">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/apio.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.mustard">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/mostaza.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.sesame">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/sesamo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.sulphites">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/sulfitos.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.lupin">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/altramuces.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="1" class="px-1 pt-0" v-show="plato.allergens.moluscs">
                                    <v-avatar size="25">
                                        <img src="@/assets/img/alergenos/moluscos.png">
                                    </v-avatar>
                                </v-col>

                            </v-row>
                        </v-card>
                    </v-col>
                </div>
                

                <v-dialog
                v-model="dialog"
                max-width="500px"
                >
                    <v-card>
                        
                        <div v-if="platoDisplay.image == null">
                            <v-img
                            height="180"
                            src="@/assets/img/restaurant/plato-default.jpg"
                            style="border-radius:5px"
                            gradient="to top left, rgba(255,255,255,.33), rgba(255,255,255,.7)"
                            >
                                <v-card-actions>
                                    <v-btn color="white darken-1" text @click="dialog = false" style="background-color: orange">X</v-btn>
                                </v-card-actions>
                            </v-img>
                        </div>
                        <div v-else>
                            <v-img
                            height="180"
                            :src="platoDisplay.img_uri_plates+'/'+platoDisplay.image"
                            style="border-radius:5px"
                            >
                                <v-card-actions>
                                    <v-btn color="white darken-1" text @click="dialog = false" style="background-color: orange">X</v-btn>
                                </v-card-actions>
                            </v-img>
                        </div>

                        <v-card-title class="pb-0">{{ platoDisplay.name }}</v-card-title>

                        <v-card-text>

                            <div style="color:grey">
                                <b>{{ platoDisplay.name_cat }}</b>
                            </div>

                            <v-divider v-show="platoDisplay.description"></v-divider>

                            <!--
                            <div v-if="platoDisplay.json.ingredients != ''">
                                <span v-for="(ingrediente2,index) in platoDisplay.json.ingredients" :key="index">{{ ingrediente2 }}, </span>
                            </div>
                            -->

                            <div class="pt-3">{{ platoDisplay.description }}</div>

                            <!-- Precio -->
                            
                            <v-row>
                                <v-col cols="4" v-if="platoDisplay.price">
                                    <b>{{ platoDisplay.col_price['es-ES'] }}</b><br>
                                    {{ formatoPrecio(platoDisplay.price) }}
                                </v-col>
                                
                                <v-col cols="4" v-if="platoDisplay.price_1">
                                    <b>{{ platoDisplay.col_price_1['es-ES'] }}</b><br>
                                    {{ formatoPrecio(platoDisplay.price_1) }}
                                </v-col>

                                <v-col cols="4" v-if="platoDisplay.price_2">
                                    <b>{{ platoDisplay.col_price_2['es-ES'] }}</b><br>
                                    {{ formatoPrecio(platoDisplay.price_2) }}
                                </v-col>

                                <v-col cols="4" v-if="platoDisplay.price_3">
                                    <b>{{ platoDisplay.col_price_3['es-ES'] }}</b><br>
                                    {{ formatoPrecio(platoDisplay.price_3) }}
                                </v-col>

                                <v-col cols="4" v-if="platoDisplay.price_4">
                                    <b>{{ platoDisplay.col_price_4['es-ES'] }}</b><br>
                                    {{ formatoPrecio(platoDisplay.price_4) }}
                                </v-col>


                            </v-row>
                            

                            <v-divider></v-divider>

                            <v-row class="text-center">
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.gluten">
                                    <small>Gluten</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/gluten.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.crutaceans">
                                    <small>Crustaceo</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/crustaceo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.eggs">
                                    <small>Huevos</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/huevo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.fish">
                                    <small>Pescado</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/pescado.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.peanut">
                                    <small>Cacahuete</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/cacahuetes.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.soya">
                                    <small>Soja</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/soja.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.milk">
                                    <small>Leche</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/lacteo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.tree_nuts">
                                    <small>Nueces</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/fruto-cascara.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.celery">
                                    <small>Apio</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/apio.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.mustard">
                                    <small>Mostaza</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/mostaza.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.sesame">
                                    <small>Sésamo</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/sesamo.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.sulphites">
                                    <small>Sulfitos</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/sulfitos.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.lupin">
                                    <small>Altramuz</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/altramuces.png">
                                    </v-avatar>
                                </v-col>
                                <v-col cols="3" class="px-1" v-show="alergenosDisplay.moluscs">
                                    <small>Molusco</small><br>
                                    <v-avatar size="40">
                                        <img src="@/assets/img/alergenos/moluscos.png">
                                    </v-avatar>
                                </v-col>

                            </v-row>

                        </v-card-text>

                    </v-card>
                </v-dialog>

                <!--
                    <v-row>
                        <v-col cols="12" class="text-left">
                            <v-select
                            v-model="alergenosSeleccionados"
                            :items="alergenosList"
                            chips
                            label="Filtro alérgenos"
                            multiple
                            hint="** Selecciona tus intolerecias y todos los platos que las contengan desaparecerán de la carta."
                            persistent-hint
                            item-value="valor"
                            item-text="texto"
                            filter
                            @change="filtrarPlatos()"
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                    -->

                <v-dialog
                v-model="dialog_alergenos"
                width="60vw"
                >
                    <v-card>
                        <v-card-actions>
                            <v-btn color="white darken-1" text @click="dialog_alergenos = false" style="background-color: orange">X</v-btn>
                        </v-card-actions>

                        <v-card-title class="pb-0" style="color:grey">Filtro alérgenos</v-card-title>

                        <v-card-text>

                            <v-divider class="my-4"></v-divider>

                            <div style="color:grey">
                                <p>** Selecciona tus intolerecias y todos los platos que las contengan desaparecerán de la carta.</p>
                            </div>

                            <v-checkbox
                            v-model="alergenosSeleccionados"
                            v-for="(alergenoShow, index) in alergenosList"
                            :key="index"
                            :label="alergenoShow.texto"
                            :value="alergenoShow.valor"
                            color="orange"
                            hide-details
                            @change="alergenoChecked()"
                            ></v-checkbox>
                        </v-card-text>

                    </v-card>
                </v-dialog>


            </v-col>
        </v-row>


    </v-container>
</template>

<script>
    import store from '@/store/index';
    import { comercio_api } from '@/api/comercio';
    import { alergenos_api } from '@/api/alergenos';
    import { categorias_api } from '@/api/categorias';
    import { platos_api } from '@/api/platos';

    export default {
        name: 'Comercio',
        data () {
            return {
                comercio: '',
                alergenos: [],
                alergenosTemp: [],
                alergenosDef: [],
                alergenosSeleccionados: [],
                alergenosList: [],
                listaCadenaAlergenos: '',
                categorias: [],
                categoriaSeleccionada: '0',
                categoriaSeleccionadaID: '',
                platos: '',
                platosFiltrados: '',
                dialog: false,
                identificador_plato: '',
                alergenosActivos: [],
                resultadoAlergenos: '',
                dialog_alergenos: false,
                alergenosDisplay: '',
                urlBase: this.$store.state.url_base,
                categoriaDescripcion: '',
                platoDisplay: {
                    col_price:'',
                    col_price_1: '',
                    col_price_2:'',
                },
            }
        },
        mounted() {
            this.urlBase = this.$store.state.urlBase

            comercio_api.getComercioSlug(window.location.pathname.substr(1))
            .then( res => {
                this.comercio = res[0];
                
                alergenos_api.getAlergenos()
                .then( res => { 
                    this.alergenosTemp = res

                    this.alergenos = Object.entries(this.alergenosTemp['es-ES']);
                    var tamano =  Object.entries(this.alergenosTemp['es-ES']).length;

                    var temp_value = '';
                    var temp_texto = '';
                    var i = 0;

                    for (i = 0; i < tamano; i++) {
                        temp_value = '';
                        temp_texto = '';
                        temp_value = this.alergenos[i][0];
                        temp_texto = this.alergenos[i][1];
                        this.alergenosDef = {"texto": temp_texto, "valor" : temp_value};
                        this.alergenosList.push(this.alergenosDef);
                    }

                    categorias_api.getCategorias(this.comercio.id)
                    .then( res => {

                        if(res[0] === 'pdf') {
                            this.$store.state.tipoElegido = 'ComercioPDF'
                        } else {
                            this.categorias = res[1]
                            this.filtrarPlatos()
                        }
                    });
                } );
            })
        },
        methods: {
            filtrarPlatos: function (index) {

                this.categoriaDescripcion = ''

                if(typeof index == 'undefined') {
                    index = this.categoriaSeleccionada
                }

                var categoriaID = this.categorias[index].id       

                this.categoriaDescripcion = this.categorias[index].description
                
                this.cadenaAlergenos()


                var filtradoPlatos = "/api/plate/lsp?id_com="+this.$store.state.comercioElegidoID+"&id_cat="+categoriaID+this.listaCadenaAlergenos;

                
                platos_api.getPlatosCom(filtradoPlatos)
                .then( res => { 
                    this.platos = res
                })
            },
            cadenaAlergenos: function () {

                var num_alergenos = this.alergenosSeleccionados.length
                this.listaCadenaAlergenos = ''

                if(num_alergenos > '0') {
                    for (var i = 0; i < num_alergenos; i++) {
                           this.listaCadenaAlergenos = this.listaCadenaAlergenos + '&' + this.alergenosSeleccionados[i] + '=0'
                    }
                }
            },
            formatoPrecio: function (precio) {

                var formatter = new Intl.NumberFormat('es-ES', {
                    style: 'currency',
                    currency: 'EUR',
                });

                precio = formatter.format(precio);
                
                return precio;
            },
            abrirModal: function (plato) {

                this.platoDisplay = plato

                this.alergenosDisplay = plato.allergens

                this.dialog = true;
            },
            abrirFiltroAlergenos: function () {

                this.dialog_alergenos = true;
                
            },
            alergenoChecked: function () {
                this.filtrarPlatos()
            }
        }
    }
</script>